import React, { memo, useCallback } from "react";
import { IconFontLayer } from "../../../../../../icon-font/iconfont-layer";
import { textStyleSet } from "../../../../../../mui-theme/text.style";
import { styles } from "./onboarding-training-widget.styles";
import { color } from "../../../../../../mui-theme/palette";
import { OnboardingTrainingWidgetProps } from "./onboarding-training-widget.types";
import { useTranslation } from "react-i18next";
import trainingLogo from "../../../../../../components/icon/assets/orientation-cource.svg"; // PHKL Custom

export const OnboardingTrainingWidgetComponent: React.FC<OnboardingTrainingWidgetProps> = memo(
  (props: OnboardingTrainingWidgetProps) => {
    const { course, onSSOClick } = props;
    const { t } = useTranslation();

    const getCardColorStyle = useCallback((status: string) => {
      /* PHKL Custom -s*/
      switch (status) {
        case "completed":
          return { statusBackgroundColor: color.greenLight, statusTextColor: color.green };
        case "in_progress":
          return { statusBackgroundColor: color.cyanLight, statusTextColor: color.cyan };
        case "enrolled":
          return { statusBackgroundColor: color.blueLight, statusTextColor: color.blue };
        default:
          return { statusBackgroundColor: color.greyBg, statusTextColor: color.grey33 };
      }
      // if (status === "completed") {
      //   return { statusBackgroundColor: color.greenLight, statusTextColor: color.green };
      // }
      // return { statusBackgroundColor: color.blueLight, statusTextColor: color.blue };
      /* PHKL Custom -e*/
    }, []);

    const mappingStatusText = useCallback(
      (status: string) => {
        switch (status) {
          case "enrolled":
            return t("Common.enrolled");
          case "in_progress":
            return t("Common.in_progress");
          case "completed":
            return t("Common.COMPLETED");
          default:
            return t("Common.in_progress");
        }
      },
      [t],
    );

    const mappingStatusDesc = useCallback(
      (status: string) => {
        switch (status) {
          case "not_enrolled":
            return t("Recruitment.complete_module_now");
          case "completed":
            return t("Recruitment.onboarding_training_completed");
          default:
            return t("Recruitment.complete_training_module_now");
        }
      },
      [t],
    );

    const cardColorStyle = getCardColorStyle(course.enrollment_status);
    // PHKL Custom -s
    // COE Original Layout
    // return (
    //   <div
    //     style={styles.contentContainer}
    //     /* PHKL Custom -s*/
    //     onClick={() => {
    //       // onSSOClick?.(course.courseId)
    //       onSSOClick?.(course.course_id);
    //       /* PHKL Custom -e*/
    //     }}
    //     className="aspect-ratio-1-1:rounded-xl"
    //   >
    //     <div className="flex flex-row items-center">
    //       {/* PHKL Custom -s*/}
    //       {/* <IconFontLayer
    //         size={36}
    //         backgroundSize={56}
    //         containerStyle={styles.iconContainer}
    //         // name="tabbar_taining_normal" // PHKL Custom
    //         name="a-mockexam" // PHKL Custom
    //         color={color.redBg}
    //       /> */}
    //       <div className="flex justify-center items-center" style={styles.trainingIcon}>
    //         <img src={trainingLogo} alt="" />
    //       </div>
    //       {/* PHKL Custom -e*/}
    //       <div className="flex flex-1 flex-col justify-center ml-3">
    //         <div className="flex flex-row items-center">
    //           <div className="flex-1">
    //             {/* PHKL Custom -s*/}
    //             <p className="text-grey33 flex-1" style={textStyleSet.text_16_med}>
    //               {course.course_name}
    //             </p>
    //             {/* <p className="text-grey33 flex-1 mt-1" style={textStyleSet.text_14_med}>
    //               {mappingStatusDesc(course.enrollment_status)}
    //             </p> */}
    //             {/* PHKL Custom -e*/}
    //           </div>
    //           <div className="flex justify-end min-w-[80px]">
    //             <div
    //               className="self-center rounded-[4px] inline-block"
    //               style={{
    //                 backgroundColor: cardColorStyle.statusBackgroundColor,
    //               }}
    //             >
    //               <p
    //                 className="px-2 py-1"
    //                 style={{ ...textStyleSet.text_12_med, color: cardColorStyle.statusTextColor }}
    //               >
    //                 {mappingStatusText(course.enrollment_status)}
    //               </p>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // );

    /* PHKL Layout */
    return (
      <div className="px-4 py-4">
        <div className="flex md:flex-row md:items-start md:gap-4">
          {/* Left info section */}
          <div className="flex flex-1">
            {/* icon */}
            <div className="w-[56px] mr-3 flex-shrink-0 flex items-start">
              <div className="flex justify-center items-center" style={styles.trainingIcon}>
                <img src={trainingLogo} alt="" />
              </div>
            </div>

            <div className="flex flex-col flex-1 min-w-0">
              <span className="text-[17px] font-semibold leading-[24px]">{course.course_name}</span>
              <div className="flex items-center gap-2 pt-1">
                <span
                  className="px-2 py-1"
                  style={{
                    backgroundColor: cardColorStyle.statusBackgroundColor,
                    color: cardColorStyle.statusTextColor,
                    ...textStyleSet.text_12_med,
                  }}>
                  {mappingStatusText(course.enrollment_status)}
                </span>
              </div>
            </div>
          </div>

          {/* Desktop buttons */}
          <div className="hidden md:flex flex-col gap-3 items-start">
            <button
              className="flex items-center justify-center w-[105px] h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
              onClick={() => onSSOClick?.(course.course_id)}>
              {t("Common.view_detail")}
            </button>
          </div>
        </div>

        {/* Mobile buttons */}
        <div className="flex gap-2 mt-6 w-full justify-end md:hidden">
          <button
            className="flex items-center justify-center w-full h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
            onClick={() => onSSOClick?.(course.course_id)}>
            {t("Common.view_detail")}
          </button>
        </div>
      </div>
    );
    // PHKL Custom -e
  },
);
